export interface PasswordStrength {
  score: number; // 0-4
  feedback: string;
  color: 'destructive' | 'warning' | 'success';
}

export const calculatePasswordStrength = (password: string): PasswordStrength => {
  if (!password) {
    return { score: 0, feedback: 'Enter a password', color: 'destructive' };
  }

  let score = 0;
  
  // Length check
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  
  // Character variety
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (/[^a-zA-Z0-9]/.test(password)) score++;

  // Determine feedback and color
  if (score <= 1) {
    return { score, feedback: 'Weak - Add more characters', color: 'destructive' };
  } else if (score <= 3) {
    return { score, feedback: 'Medium - Add special characters', color: 'warning' };
  } else {
    return { score, feedback: 'Strong password', color: 'success' };
  }
};
